import { render, staticRenderFns } from "./inputRecord.vue?vue&type=template&id=7f389626&scoped=true"
import script from "./inputRecord.vue?vue&type=script&lang=js"
export * from "./inputRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f389626",
  null
  
)

export default component.exports